<template>
  <div style="height: 100%; width: 100%;">
    <l-map v-show="presetLayer" ref="map" :zoom="zoom" :center="center" :class="'wapi_map__map'">
      <l-tile-layer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"></l-tile-layer>
      <l-geo-json
        ref="geoJsonLayerPresets"
        v-for="geoJson in geojsons"
        :geojson="geoJson"
        :options="geoJsonOptions"
        :key="geoJson.id"
        @click="geoJsonClick(geoJson)"
      ></l-geo-json>
      <l-geo-json ref="geoJsonLayerDomain" :geojson="geojsondomain" :options="domainGeoJsonOptions"></l-geo-json>
      <l-control :position="'topright'">
        <wapi-panel :title="'Настройки'" collapsible :min-width="374">
          <template v-slot:content>
            <v-select
              v-model="domainName"
              :items="domains"
              item-text="name"
              item-value="name"
              label="Выберите домен"
              dense
              outlined
              @input="onChangeDomain"
              :loading="domainsLoading"
            ></v-select>
            <v-select
              v-model="userId"
              :items="users"
              item-text="name"
              item-value="id"
              label="Клиент"
              dense
              outlined
              @input="onChangeUser"
              :loading="presetsLoading"
            ></v-select>
            <wapi-presets
              v-model="selectedPresets"
              @on-slow="slowOperation"
              :disabled="false"
              :multiple="multiple"
              :userId="userId"
              :initCheckAll="initCheckAll"
            />
          </template>
        </wapi-panel>
      </l-control>
      <l-control :position="'bottomright'">
        <wapi-panel-closed
          :title="'Территория'"
          collapsible
          :min-width="374"
          @close="onPresetInfoClose"
          :show="infoShowing"
          :spacing="false"
        >
          <template v-slot:content>
            <wapi-preset-card-info :preset="preset" @open-preset="openPreset" />
          </template>
        </wapi-panel-closed>
      </l-control>
    </l-map>
  </div>
</template>

<script>
import settings from "../settings.json";
import WapiPresets from "../components/WapiPresets.vue";
import WapiPresetCardInfo from "../components/WapiPresetCardInfo.vue";
import WapiPanel from "../components/WapiPanel.vue";
import WapiPanelClosed from "../components/WapiPanelClosed.vue";
import { wapiPolygon2DToGeoJson } from "../helpers/wapihelpers";
import { areaInKm2 } from "../helpers/common.js";

export default {
  name: "DomainsMapView",
  title: "Карта доменов",
  components: {
    WapiPresets,
    WapiPanel,
    WapiPresetCardInfo,
    WapiPanelClosed
  },
  data() {
    return {
      componentKey: 0,
      localLoading: false,
      domainsLoading: false,
      clientsLoading: false,
      presetsLoading: false,
      presetLayer: true,
      initCheckAll: false,
      center: settings.center,
      domains: [],
      domainName: "",
      users: [],
      userId: "",
      presets: [],
      preset: {},
      selectedPresets: [],
      geojsondomain: null,
      zoom: 13,
      fillColor: "#FF0000",
      domainGeoJsonOptions: {
        onEachFeature: (feature, layer) => {
          if (this.loading) return;
          const bounds = layer.getBounds();
          layer.getLatLng = function() {
            return this.getBounds().getCenter();
          };
          layer.setLatLng = function() {};
          layer._latlng = layer.getLatLng();
          this.$refs.map.mapObject.fitBounds(bounds);
        }
      },
      geoJsonOptions: {
        onEachFeature: (feature, layer) => {
          const fillColor = this.fillColor; // important! need touch fillColor in computed for re-calculate when change fillColor
          layer.setStyle({
            weight: 0.2,
            color: "#3388ff",
            opacity: 1,
            fillColor: fillColor,
            fillOpacity: 0.6
          });

          if (this.loading) return;

          const bounds = layer.getBounds();
          const center = bounds.getCenter();
          this.center = center;
          layer.getLatLng = function() {
            return this.getBounds().getCenter();
          };
          layer.setLatLng = function() {};
          layer._latlng = layer.getLatLng();
        }
      },
      noData: false,
      multiple: true,
      infoShowing: false,
      load: false
    };
  },
  async created() {
    this.domainsLoading = true;
    this.clientsLoading = true;
    this.domains = await this.$store.dispatch("FETCH_DOMAINS");
    this.domainsLoading = false;
    this.setFirstDomain();
    await this.onChangeDomain();
    this.users = await this.$store.dispatch("FETCH_USERS");
    this.setFirstUser();
    this.clientsLoading = false;
  },
  watch: {
    checkAll(value) {
      if (value) {
        const ids = this.presets.map(x => x.id);
        this.selectedPresets = ids;
      } else {
        this.selectedPresets = [];
      }
    },
    preset() {
      this.infoShowing = true;
    }
  },
  computed: {
    geojsons: function() {
      const areas = this.selectedPresets.map(x => x.geoJson);
      return areas;
    },
    loading() {
      return this.$store.getters.LOADING;
    },
    anyPreset: function() {
      return this.presets.length > 0;
    },
    styleFunction() {
      const fillColor = this.fillColor; // important! need touch fillColor in computed for re-calculate when change fillColor
      return () => {
        return {
          weight: 0.2,
          color: "#ECEFF1",
          opacity: 1,
          fillColor: fillColor,
          fillOpacity: 1
        };
      };
    }
  },
  methods: {
    onPresetInfoClose() {
      this.infoShowing = false;
    },
    async geoJsonClick(geoJson) {
      const preset = await this.$store.dispatch("FETCH_PRESET", {
        id: geoJson.properties.id,
        user_id: geoJson.properties.user_id
      });
      this.preset = preset;
    },
    areaInKm(geojson) {
      const area = Math.round(areaInKm2(geojson.geometry));
      return area;
    },
    areaInHa(geojson) {
      const area = Math.round(areaInKm2(geojson.geometry));
      return area;
    },
    async onChangeDomain() {
      const domain = this.domains.find(d => d.name === this.domainName);
      if (domain) {
        this.geojsondomain = wapiPolygon2DToGeoJson(domain);
      }
    },
    async onChangeUser() {
      this.noData = !this.presets.length;
    },
    slowOperation(enable) {
      this.presetLayer = !enable;
    },
    setFirstDomain() {
      if (!this.domains.length) return;
      this.domainName = this.domains[0].name;
    },
    setFirstUser() {
      if (!this.domains.length) return;
      if (!this.users.length) return;
      this.userId = this.users[0].id;
    },
    openPreset(preset) {
      this.$router.push({
        name: "PRESET_DETAILS",
        params: { userId: preset.user_id, presetId: preset.id }
      });
    }
  }
};
</script>